import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Questionnaire from "@/pages/Questionnaire";
import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
import PaymentResult from "@/pages/PaymentResult";
import Confidentialite from "@/pages/Confidentialite";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ConfirmEmail from "@/pages/ConfirmEmail";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0F0D]">
        <div className="h-10 w-10 rounded-full border-2 border-lime-400 border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Navigate to="/questionnaire" replace />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/confirm-email" element={<ConfirmEmail />} />
      <Route path="/politique-confidentialite" element={<Confidentialite />} />
      <Route path="/questionnaire" element={<Questionnaire />} />
      <Route path="/app" element={<Navigate to="/programme" replace />} />
      <Route path="/programme" element={<Protected><Home /></Protected>} />
      <Route path="/seance" element={<Protected><Home /></Protected>} />
      <Route path="/progres" element={<Protected><Home /></Protected>} />
      <Route path="/bilan" element={<Protected><Home /></Protected>} />
      <Route path="/profil" element={<Protected><Home /></Protected>} />
      <Route path="/pricing" element={<Protected><Pricing /></Protected>} />
      <Route path="/payment/success" element={<Protected><PaymentResult /></Protected>} />
      <Route path="/payment/cancel" element={<Protected><PaymentResult /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" theme="dark" richColors />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
